import React, { Component } from 'react';
import { Header, Segment, Label, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class ContactMe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      hasRequestedContact: false,
      requestContactFailed: false,
    };
  }

  onValidSubmit = formData => {
    const { navn, epost, telefonnummer } = formData;

    this.setState({ loading: true });

    const payload = {
      Field1: navn,
      Field4: epost,
      Field6: telefonnummer,
    };

    fetch('https://api.hanen.no/bli-medlem', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(res => {
        this.setState({ loading: false });
        return res.json();
      })
      .then(({ Success, FieldErrors }) => {
        if (Success === 1) {
          this.setState({ hasRequestedContact: true });
        } else if (Success === 0) {
          Promise.reject(new Error(FieldErrors[0].ErrorText));
        } else {
          Promise.reject(new Error('Svaret fra Wufoo gir ikke mening!'));
        }
      })
      .catch(error => {
        console.log('ContactMe.js -> onValidSubmit', error);
        this.setState({
          requestContactFailed: true,
        });
      });
  };

  render() {
    const { tittel, navn, telefonnummer, epost, knappTekst } = this.props;
    const { hasRequestedContact, requestContactFailed, loading } = this.state;

    const errorLabel = <Label color="red" pointing basic />;

    return (
      <Segment basic id="bli-kontaktet">
        <Header as="h1">
          <span dangerouslySetInnerHTML={{ __html: tittel }} />
        </Header>
        <Segment>
          {hasRequestedContact ? (
            <p>
              Takk for din henvendelse. Vi tar kontakt med deg så snart vi kan!
            </p>
          ) : (
            <Form onValidSubmit={this.onValidSubmit}>
              <Form.Input
                name="navn"
                label={navn}
                required
                validationErrors={{
                  isDefaultRequiredValue: 'Navn er påkrevd',
                }}
                errorLabel={errorLabel}
              />
              <Form.Group widths="equal">
                <Form.Input
                  name="telefonnummer"
                  label={telefonnummer}
                  required
                  validationErrors={{
                    isDefaultRequiredValue: 'Telefonnummer er påkrevd',
                  }}
                  errorLabel={errorLabel}
                />
                <Form.Input
                  name="epost"
                  label={epost}
                  required
                  validations="isEmail"
                  validationErrors={{
                    isEmail: 'Dette er ikke en gyldig e-post adresse',
                    isDefaultRequiredValue: 'E-post er påkrevd',
                  }}
                  errorLabel={errorLabel}
                />
              </Form.Group>
              <Form.Button loading={loading}>{knappTekst}</Form.Button>
              {requestContactFailed ? (
                <Message negative>
                  Det skjedde en feil. Prøv igjen senere eller ta kontakt med
                  oss direkte.
                </Message>
              ) : null}
            </Form>
          )}
        </Segment>
      </Segment>
    );
  }
}

export default ContactMe;



// WEBPACK FOOTER //
// ./src/LandingPage/ContactMe.js